import { useDispatch, useSelector } from 'react-redux';
import { checkPermissions } from 'src/slices/utils';
import Button from '../atoms/Button';
import css from './OrderStatusChangerSimple.module.scss';
import Pill from '../atoms/Pill';
import { updateOrder, pastOrderDetails } from 'src/slices/order';
import { getOrderStatusColor } from 'src/utils/designUtils';

export default function OrderStatusChangerSimple({ order, handleCancel }) {
  const dispatch = useDispatch();
  const { permissions } = useSelector((state) => state.auth);

  const handleUpdateStatus = (status, orderId) => {
    const data = {
      status: status,
      reason: 'none',
      orderId,
    };

    dispatch(updateOrder(data));
    dispatch(pastOrderDetails(orderId));
  };

  // received, processing, ready, complete/cancelled

  async function handleComplete() {
    await handleUpdateStatus('complete', order._id);
    //await handleUpdateStatus('complete', order._id);
  }

  return (
    <>
      {/* checkPermissions(permissions, { update: ['orders'] }).hasPermission &&
          !['cancelled', 'complete'].includes(order.status) */}

      {['complete', 'cancelled'].includes(order.status) ? (
        <Pill
          color={getOrderStatusColor(order.status).slice(0, -4)}
          variant="secondary"
          size="xs"
          label={order.status}
          style={{ marginLeft: 'auto' }}
        />
      ) : checkPermissions(permissions, { update: ['orders'] }).hasPermission ? (
        <div className={css['order-actions']}>
          {/* {order.status} */}
          <Button
            label="Cancel"
            variant="secondary"
            color="gray"
            size="xs"
            iconLeft="fad fa-trash"
            iconLeftColor="red-500"
            action={(e) => {
              e.stopPropagation();
              handleCancel(order);
            }}
          />
          {order.status === 'received' ? (
            <Button
              label="Confirm"
              variant="secondary"
              color="gray"
              size="xs"
              iconLeft="fad fa-inbox-in"
              iconLeftColor="emerald-500"
              action={(e) => {
                e.stopPropagation();
                handleUpdateStatus('processing', order._id);
              }}
            />
          ) : (
            <Button
              label="Complete"
              variant="secondary"
              color="gray"
              size="xs"
              iconLeftColor="emerald-500"
              iconLeft="fad fa-check fa-swap-opacity"
              action={(e) => {
                e.stopPropagation();
                handleComplete();
              }}
            />
          )}
        </div>
      ) : (
        ''
      )}
    </>
  );
}
